import React from "react"
import classNames from "classnames"
import { Snackbar as MuiSnackbar, Slide, SlideProps } from "@mui/material"

import Icon from "@/components/icon/Icon"
import { colorTokens } from "@/components/colorTokens"
import { SnackbarProps } from "@/types/components/snackbar"
import { CustomIconType, RemixIconType } from "@/types/components/icon"

import "./snackbar.scss"

const typeMap: { [key: string]: RemixIconType | CustomIconType } = {
  success: "check-fill",
  warning: "warning-fill",
  error: "alert-fill",
}

const SlideTransition = (props: SlideProps) => {
  return <Slide {...props} direction="down" />
}

function Snackbar({ severity, className, ...props }: SnackbarProps) {
  const mergedClassName = classNames("SnackbarCont", className, severity)

  return (
    <MuiSnackbar
      {...props}
      className={mergedClassName}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={5000}
      message={
        <div className="Snackbar-message">
          <Icon type={typeMap[severity]} size={24} />
          {props.message}
          <span onClick={(e) => props.onClose && props.onClose(e, "timeout")}>
            <Icon type="close" size={16} color={colorTokens.icon.disabled} />
          </span>
        </div>
      }
      onClose={(event, reason) => {
        if (reason === "clickaway" || reason === "escapeKeyDown") {
          // 외부 클릭 / esc 누를 시 닫힘 방지
          return
        }
        props.onClose?.(event, reason)
      }}
      TransitionComponent={SlideTransition}
    />
  )
}

export default React.memo(Snackbar, (prevProps, nextProps) => {
  // open, message, severity만 비교 (onClose는 무시)
  return (
    prevProps.open === nextProps.open &&
    prevProps.message === nextProps.message &&
    prevProps.severity === nextProps.severity
  )
})
